import type { FC } from "react";

import { EllipsisDropdownItem, ChipDownContainer } from "@similarweb/ui-components";

import { translate } from "app/filters/i18nFilter";
import { allTrackers } from "app/services/track/track";

export enum EChangeFilterValues {
    Trending = "Trending",
    DeTrending = "DeTrending",
    NewClicks = "New",
    LostClicks = "Lost",
    All = "All",
}
export interface IChangeFilterItems {
    text: string;
    id: EChangeFilterValues;
    tooltip: string;
}
interface IChangeFilterProps {
    onChangeFilterChange: (value?: string) => void;
    selectedValue: EChangeFilterValues;
    changeFilterItems: IChangeFilterItems[];
    defaultFilterText?: string;
}

export const ChangeFilter: FC<IChangeFilterProps> = ({
    onChangeFilterChange,
    selectedValue,
    changeFilterItems,
    defaultFilterText = "change.filter.default.text",
}) => {
    const selectedItem = changeFilterItems.find((item) => item.id === selectedValue);

    const onClick = (value) => {
        allTrackers.dispatchTrackEvent("Filter Table", "click", `Filter Applied/${value.id || ""}`);
        onChangeFilterChange(value.id);
    };

    const onChipdownToggle = (isOpen: boolean) => {
        if (isOpen) {
            allTrackers.dispatchTrackEvent("Drop Down", "click", "Open Dropdown");
        }
    };

    return (
        <ChipDownContainer
            width={138}
            onClick={onClick}
            tooltipDisabled={true}
            selectedText={selectedItem?.text}
            onCloseItem={() => onChangeFilterChange()}
            buttonText={translate(defaultFilterText)}
            onToggle={onChipdownToggle}
            noResultsMessage={translate("dropdown.no.results")}
        >
            {changeFilterItems.map((item, index) => {
                return (
                    <EllipsisDropdownItem
                        selected={selectedValue === item.id}
                        id={item.id}
                        key={index}
                        tooltipText={item.tooltip}
                    >
                        {item.text}
                    </EllipsisDropdownItem>
                );
            })}
        </ChipDownContainer>
    );
};
